import { Icon } from '../icon/icon'

import styles from './error-toast.module.scss'

interface IErrorToastProps {
    text: string
}

export const ErrorToast = ({ text }: IErrorToastProps): React.ReactNode => {
    return (
        <div className={styles['error-toast']}>
            <div className={styles['error-toast__icon']}>
                <Icon
                    color='var(--extensions-text-and-icon-always-light)'
                    icon='warningFill'
                    size={24}
                />
            </div>
            <span className={styles['error-toast__text']}>{text}</span>
        </div>
    )
}
